import { Routes } from "@angular/router";
import { WorkflowEndcustomerAiTariffComponent } from "./workflow-endcustomer-ai-tariff.component";

export const workflowEndcustomerAiTariffRouting: Routes = [
    { path: 'change-ai-tariff/:aid', component: WorkflowEndcustomerAiTariffComponent, children: [
        { path: 'choose-ai-tariff', component: WorkflowEndcustomerAiTariffComponent, data: { step: 'choose-ai-tariff' } },
        { path: 'delivery-date', component: WorkflowEndcustomerAiTariffComponent, data: { step: 'delivery-date' } },
        { path: 'invoice-address', component: WorkflowEndcustomerAiTariffComponent, data: { step: 'invoice-address' } },
        { path: 'payment', component: WorkflowEndcustomerAiTariffComponent, data: { step: 'payment-method' } },
        { path: 'checkout-summary', component: WorkflowEndcustomerAiTariffComponent, data: { step: 'checkout-summary' } },
        { path: 'thank-you', component: WorkflowEndcustomerAiTariffComponent, data: { step: 'thank-you' } },
        { path: '', redirectTo: 'choose-ai-tariff', pathMatch: 'full' },
    ]},
]